import React, { Component } from 'react';
import './Footer.css';
import { Container } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { FormattedHTMLMessage } from 'react-intl';

class Footer extends Component {
    render() {
        const year = new Date().getFullYear();
        return (
            <footer className="footer footer-black footer-big mt-auto py-3">
                <Container>
                    <div className="footer-container">
                        <div className="links">
                            <ul>
                                <li className="pl-1 pr-1">
                                    <FormattedHTMLMessage id="footer.link.privacy" />
                                </li>
                                |
                                <li className="pl-1 pr-1">
                                    <FormattedHTMLMessage id="footer.link.copyright" />
                                </li>
                                |
                                <li className="pl-1 pr-1">
                                    <FormattedHTMLMessage id="footer.link.terms" />
                                </li>
                            </ul>
                        </div>
                        <div className="copy-rights">
                            <FormattedMessage
                                id="footer.copyright"
                                values={{ year }}
                            />
                        </div>
                    </div>

                </Container>

            </footer>
        );
    }
}

export default Footer;